import styled from 'styled-components'
import { Login, FontSizeText, FontSizeParagraph, Button } from '../../assets'

export const FormContainer = styled.form`
    margin-top: 25px;
    width: 295px;
    .form-group {
        width: 330px;
    }
    .link-container {
        padding-top: 15px;
        padding-bottom: 20px;
    }
    .link-container a {
        color: ${Button.primary.defaultColor.active.color};
    }
    @media screen and (min-width: 992px) {
        margin-top: 0;
        width: 300px;
        .form-group {
            width: 300px;
        }
    }
`

export const LinkContainer = styled.div`
    margin-top: 30px;
    font-size: 14px;
    width: 295px;
    a {
        color: ${Login.link.color};
        text-decoration: underline;
    }
    @media screen and (max-width: 992px) {
        margin-top: 0;
    }
`

export const SectionWrapper = styled.section`
    background: white;
    padding: 40px 45px 0 45px;
    border-radius: 10px;
    box-shadow: 0 0 16px 12px rgba(59, 83, 99, 0.06);
    @media screen and (max-width: 992px) {
        background: transparent;
        box-shadow: none;
        padding: 0;
    }
`
export const ButtonContainer = styled.div`
    margin: 0 0 40px;
    @media screen and (min-width: 992px) {
        margin: 20px 0 0;
    }
`

export const Separator = styled.div`
    margin: 10px 0 10px 0;
    border-top: ridge #ebebeb 1px;
`

export const ContainerTitle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    @media screen and (max-width: 992px) {
        display: none;
    }
`

export const ContainerError = styled.div`
    border-radius: 10px;
    border: solid 1px #ff4445;
    background-color: #ffdcdc;
    padding: 13px 12px 10px 11.6px;
    i {
        color: red;
        font-size: 18px;
    }
`
export const TitleError = styled.p`
    text-align: center;
    font-size: ${FontSizeText};
    color: #ff4445;
    margin: 0;
    font-weight: bold;
`

export const DescriptionError = styled.p`
    font-size: ${FontSizeParagraph};
    text-align: left;
    margin: 0 auto;
    width: 80%;
`
